export default {
  city: (data, p) => ({
    title: `Запчасти на автобус купить ${p.inCity} - Автобазар`,
    title_uk: `Запчастини на автобус купити ${p.inCity} - Автобазар`,

    description: `Купить запчасти на автобус ${p.inCity}. Большой каталог запчастей для автобусов ${p.inCity} на Автобазар. В продаже запчасти на автобусы бу и новые от официальных интернет магазинов, авторазборок и частных лиц`,
    description_uk: `Купити запчастини на автобус ${p.inCity}. Великий каталог запчастин для автобусів ${p.inCity} на Автобазар. У продажу запчастини на автобуси бу і нові від офіційних інтернет магазинів, авторазборок і приватних осіб`,

    header: `Запчасти на автобус ${p.inCity}`,
    header_uk: `Запчастини на автобус ${p.inCity}`,
  }),

  make_model: (data, p) => ({
    header: `Запчасти на автобусы ${data.make} ${data.model} в Украине`,
    header_uk: `Запчастини на автобуси ${data.make} ${data.model} в Україні`,
  }),
};



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avtobus/templates.js